import React, {FC, useState} from "react"
import {Dropdown, DropdownProps} from "@fluentui/react-northstar"
import {CompanyValue} from "../../types"
import {FormLabel} from "./styles"
import {Pair} from "./index";

interface Props {
    companyValues: CompanyValue[],
    onCompanyValuesChange: (newValues: Pair[]) => void,
    disabled?: boolean,
    businessName?: string
}

const CompanyValues: FC<Props> = ({companyValues, onCompanyValuesChange, disabled, businessName}) => {
    const [selectedCompanyValues, setSelectedCompanyValues] = useState<any>([])

    const handleSelectCompanyValuesChange = (_: any, {value}: DropdownProps) => {
        if (value && Array.isArray(value)) {
            setSelectedCompanyValues(value)
            const newValues: Pair[] = value.map((v: any) => ({uuid: v.uuid, name: v.header}))
            onCompanyValuesChange(newValues)
        }
    }

    const getCurrentValues = () => {
        return selectedCompanyValues.map((currentValue: any) => {
            return {
                ...currentValue,
                styles: {
                  fontWeight: "normal",
                  gap: "8px",
                  padding: "0px 10px 0px 24px",
                }
            }
        })
    }

    if(!businessName) {
        return null
    }

    return (
        <div>
            <FormLabel>
              {businessName} values
            </FormLabel>
            <Dropdown
                multiple
                search
                fluid
                value={getCurrentValues()}
                disabled={disabled}
                styles={{
                  padding: "0px",
                  margin: "3px 0px"
                }}
                placeholder="Start typing to search"
                noResultsMessage="No match found"
                onChange={handleSelectCompanyValuesChange}
                items={companyValues.map(({name, uuid}) => ({header: name, uuid}))}
            />
        </div>
    )
}

export default CompanyValues
